import { array, number, object } from 'yup';

export type ConstructionItemSetting = {
  id: number;
  companyMasterId: number;
  vendorCompanyId: number;
  constructionItemId: number;
  unitAmount: number | null;
};

export type ConstructionItemSettingEdit = Omit<
  ConstructionItemSetting,
  'companyMasterId' | 'vendorCompanyId' | 'id'
>;

export const validationSchemaConstructionItemSetting = array().of(
  object().shape({
    unitAmount: number().nullable().required('入力してください')
  })
);
